import React from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import cx from "classnames";

import { Select } from "../index";
import { FundedComplianceAPI, FUNDED_COMPLIANCE_API_URLS } from "../../../api/fundedCompliance";
import { FUNDS_API_URLS } from "../../../api/funds";
import { EVALUATIONS_API_URLS } from "../../../api/evaluations";
import s from "./styles.module.css";

interface IOptions {
  label: string | number;
  value: string | number | boolean;
}

interface IComplianceStatusSelectProps {
  status: string;
  id: number;
}

export const COMPLIANCE_STATUS_OPTIONS: IOptions[] = [
  {
    label: "New",
    value: "new",
  },
  {
    label: "Ok to process",
    value: "ok_to_process",
  },
  {
    label: "Under review",
    value: "under_review",
  },
  {
    label: "Last account, ban",
    value: "last_account_ban",
  },
  {
    label: "Last Live account, ban",
    value: "last_live_account_ban",
  },
  {
    label: "No account, ban",
    value: "no_account_ban",
  },
  {
    label: "Forced Live",
    value: "forced_live",
  },
  {
    label: "Live",
    value: "live",
  },
  {
    label: "Trailing Livesim",
    value: "trailing_livesim",
  },
  {
    label: "Sent for review",
    value: "sent_for_review",
  },
  {
    label: "Revoked",
    value: "revoked",
  },
];
const AccountComplianceStatusSelect: React.FC<IComplianceStatusSelectProps> = ({ status, id }) => {
  const queryClient = useQueryClient();

  const { mutate: updateSubmissionToPropRecord } = useMutation({
    mutationKey: [FUNDED_COMPLIANCE_API_URLS.submissionToPropList, "updateSubmissionToPropRecord"],
    mutationFn: async (compliance_status: string) => {
      await FundedComplianceAPI.updateSubmissionToPropRecordRequest({
        id,
        compliance_status,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [FUNDED_COMPLIANCE_API_URLS.submissionToPropList],
      });
      queryClient.invalidateQueries({
        queryKey: [FUNDS_API_URLS.funds],
      });
      // invalidates query in funded trader profile page
      queryClient.invalidateQueries({
        queryKey: [EVALUATIONS_API_URLS.customerEvaluationCompleteHistory],
      });
    },
    onError: () => {
      console.log("Error updating submission to prop record");
    },
  });

  return (
    <div>
      <Select
        baseSelectStyles={{
          className: cx("baseSelect", s[status]),
          classes: { root: s.rootBaseSelect },
        }}
        size="small"
        value={status || ""}
        onChange={(e) => updateSubmissionToPropRecord(e.target.value as string)}
        options={COMPLIANCE_STATUS_OPTIONS.map((opt) => ({
          text: opt.label as string,
          name: opt.value,
        }))}
      />
    </div>
  );
};

export default AccountComplianceStatusSelect;
